import React, { useEffect } from 'react'
import { Grid, Typography, styled } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { getLessons } from '../../actions/typeOfLesson'
import LessonTable from './LessonTable'
import { Link } from 'react-router-dom'
import MyButton from '../ui/MyButton'
import AddIcon from '@mui/icons-material/Add'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Spinner from '../ui/Spinner'
import { RootState } from '../../reducers'

const Wrapper = styled(Grid)(({ theme }) => ({
  paddingLeft: '1.5em',
  paddingRight: '1.5em',
  [theme.breakpoints.up('sm')]: {
    paddingLeft: '3em',
    paddingRight: '3em',
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: '5em',
    paddingRight: '5em',
  },
}))

const Lessons: React.FC = () => {
  const dispatch = useDispatch()

  const typeOfLesson = useSelector((state: RootState) => state.typeOfLesson)

  const { lessons, loading } = typeOfLesson

  useEffect(() => {
    dispatch(getLessons())
  }, [dispatch])

  if (loading) {
    return <Spinner />
  }

  return <>
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ width: '100%', margin: '7em 0 0' }}
      spacing={2}
    >
      <Grid item>
        <Typography
          variant="h4"
          style={{ textTransform: 'uppercase', fontWeight: 500 }}
        >
          Types Of Lesson Management
        </Typography>
      </Grid>
      <Grid item>
        {lessons && lessons.length > 0 ? (
          <LessonTable lessons={lessons} />
        ) : (
          <Typography variant="body1">
            There are not any types of lesson yet, please add some.
          </Typography>
        )}
      </Grid>
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        style={{ margin: '0 0 2em', width: '100%' }}
        spacing={3}
      >
        <Grid item>
          <MyButton component={Link} to="/teachers/dashboard">
            <ArrowBackIcon />
            &nbsp; Back to dashboard
          </MyButton>
        </Grid>
        <Grid item>
          <MyButton component={Link} to="/teachers/add-a-lesson">
            <AddIcon />
            &nbsp; Add a type of lesson
          </MyButton>
        </Grid>
      </Grid>
    </Wrapper>
  </>;
}

export default Lessons
